<template>
	<section class="home_item"><slot></slot></section>
</template>
<script setup lang="ts"></script>

<style lang="scss" scoped>
.home_item {
	display: flex;
	flex-direction: column;
	gap: 2rem;
	font-size: var(--font-s-x-large);
	font-weight: var(--font-w-bold);
}
</style>
